export enum SocketEvent {
    // ONE VERIFY
    oneVerifyJoinRoom = "oneVerifyJoinRoom",
    oneVerifyLeaveRoom = "oneVerifyLeaveRoom",
    oneVerifyPolicyCommentCreated = "oneVerifyPolicyCommentCreated",
    // EHR Write specific events
    oneVerifyEhrWriteStatusUpdated = "oneVerifyEhrWriteStatusUpdated",
    // Single toast message, will be displayed as toast
    oneVerifySingleToastMsg = "oneVerifySingleToastMsg",

    // LABELING PORTAL
    labelingPortalJoinRoom = "labelingPortalJoinRoom",
    labelingPortalLeaveRoom = "labelingPortalLeaveRoom",
    labelingPortalTaskUpdated = "labelingPortalTaskUpdated",
}
